(function() {
  'use strict';

  var popup = document.getElementById('as-popup-overlay');
  if (!popup) return;

  var CONFIG = {
    cookieName: 'as_popup_dismissed',
    cookieDays: parseInt(popup.getAttribute('data-cookie-days'), 10) || 7,
    timeDelay: parseInt(popup.getAttribute('data-time-delay'), 10) || 1500,
    scrollThreshold: parseInt(popup.getAttribute('data-scroll-threshold'), 10) || 60,
    mlAccountId: popup.getAttribute('data-ml-account') || ''
  };
  var enabled = popup.getAttribute('data-enabled') === 'true';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  var container = popup.querySelector('.as-popup-container');
  var closeBtn = popup.querySelector('.as-popup-close');
  var choiceScreen = document.getElementById('as-popup-choice');
  var panels = Array.prototype.slice.call(popup.querySelectorAll('.as-popup-guide-panel'));
  var forms = Array.prototype.slice.call(popup.querySelectorAll('.as-popup-form'));
  var popupShown = false;
  var timersSet = false;

  function panelByGuide(g) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-guide') === g) return panels[i];
    }
    return null;
  }

  function showChoice() {
    if (choiceScreen) choiceScreen.style.display = 'block';
    each(panels, function(p) { p.style.display = 'none'; });
    if (container) container.scrollTop = 0;
  }
  function showGuideForm(g) {
    if (choiceScreen) choiceScreen.style.display = 'none';
    each(panels, function(p) {
      if (p.getAttribute('data-guide') === g) {
        p.style.display = 'flex';
        var fv = p.querySelector('.as-popup-form-view');
        var sv = p.querySelector('.as-popup-success-view');
        if (fv) fv.style.display = '';
        if (sv) sv.style.display = 'none';
      } else {
        p.style.display = 'none';
      }
    });
    if (container) container.scrollTop = 0;
  }
  function showGuideSuccess(g) {
    var panel = panelByGuide(g);
    if (!panel) return;
    var fv = panel.querySelector('.as-popup-form-view');
    var sv = panel.querySelector('.as-popup-success-view');
    if (fv) fv.style.display = 'none';
    if (sv) sv.style.display = 'block';
    if (container) container.scrollTop = 0;
  }

  function showPopup() {
    if (popupShown) return;
    // Un cookie di soppressione blocca il popup. Il vecchio valore 'subscribed' (365 giorni)
    // viene ignorato: i vecchi iscritti rientrano subito nel ciclo di cookie_days.
    var dismissed = getCookie(CONFIG.cookieName);
    if (dismissed && dismissed !== 'subscribed') return;
    popupShown = true;
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  function hidePopup(setFlag) {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    if (setFlag) setCookie(CONFIG.cookieName, '1', CONFIG.cookieDays);
  }

  // Scelta guida (schermata 1)
  each(popup.querySelectorAll('[data-choose]'), function(btn) {
    btn.addEventListener('click', function() { showGuideForm(btn.getAttribute('data-choose')); });
  });

  // Azioni: cambia guida / altra guida / chiudi
  popup.addEventListener('click', function(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-action]') : null;
    if (!t || !popup.contains(t)) return;
    var action = t.getAttribute('data-action');
    if (action === 'change-guide') showChoice();
    else if (action === 'cross-sell') showGuideForm(t.getAttribute('data-target'));
    else if (action === 'close') hidePopup(true);
  });

  if (closeBtn) closeBtn.addEventListener('click', function() { hidePopup(true); });
  popup.addEventListener('click', function(e) { if (e.target === popup) hidePopup(true); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.style.display === 'flex') hidePopup(true);
  });

  // Invio form (uno per guida, Form ID nel data-attribute)
  each(forms, function(form) {
    var guide = form.getAttribute('data-guide');
    var submitBtn = form.querySelector('.as-popup-submit');
    var messageDiv = form.querySelector('.as-popup-message');
    var ctaText = submitBtn ? submitBtn.textContent : 'Invia';

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var name = form.querySelector('.as-popup-name').value.trim();
      var email = form.querySelector('.as-popup-email').value.trim();
      var consent = form.querySelector('.as-popup-consent').checked;
      var formId = form.getAttribute('data-form-id');

      if (!name || !email || !consent) {
        messageDiv.textContent = 'Compila i campi e accetta la privacy policy.';
        messageDiv.className = 'as-popup-message error';
        return;
      }
      if (!formId) {
        messageDiv.textContent = 'Questa guida non è ancora disponibile. Riprova tra poco.';
        messageDiv.className = 'as-popup-message error';
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Invio in corso...';
      messageDiv.textContent = '';
      messageDiv.className = 'as-popup-message';

      var formData = new FormData();
      formData.append('fields[email]', email);
      formData.append('fields[name]', name);
      formData.append('ml-submit', '1');
      formData.append('anticsrf', 'true');

      fetch('https://assets.mailerlite.com/jsonp/' + CONFIG.mlAccountId + '/forms/' + formId + '/subscribe', {
        method: 'POST',
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success || data.ok || data.account_id) {
          showGuideSuccess(guide);
          // Iscrizione trattata come la chiusura: stesso cookie e stessa durata (cookie_days).
          setCookie(CONFIG.cookieName, '1', CONFIG.cookieDays);
          if (typeof gtag !== 'undefined') {
            gtag('event', 'lead_magnet_signup', { 'event_category': 'engagement', 'event_label': 'popup_' + guide });
          }
        } else {
          throw new Error('Errore di iscrizione');
        }
      })
      .catch(function() {
        messageDiv.textContent = 'Si è verificato un errore. Riprova o scrivi a info@alimentazionestrategica.com';
        messageDiv.className = 'as-popup-message error';
        submitBtn.disabled = false;
        submitBtn.textContent = ctaText;
      });
    });
  });

  function isMobile() { return window.innerWidth < 768 || 'ontouchstart' in window; }

  function setupTriggers() {
    if (timersSet) return;
    timersSet = true;

    setTimeout(showPopup, CONFIG.timeDelay);

    if (!isMobile()) {
      document.addEventListener('mouseleave', function(e) { if (e.clientY <= 0) showPopup(); });
    } else {
      var scrollHandler = function() {
        var docHeight = document.body.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return;
        var pct = (window.scrollY / docHeight) * 100;
        if (pct >= CONFIG.scrollThreshold) {
          showPopup();
          window.removeEventListener('scroll', scrollHandler);
        }
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }
  }

  if (enabled) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupTriggers);
    } else {
      setupTriggers();
    }
  }
})();
